import { Menu, IconButton, MenuList, MenuItem, Box } from '@chakra-ui/react'
import { faClone, faEllipsis } from '@fortawesome/pro-regular-svg-icons'
import { AnimatePresence, motion } from 'framer-motion'
import { useRecoilValue } from 'recoil'
import { ItList } from 'types/graphql'

import { navigate } from '@redwoodjs/router'

import { backUrlState } from 'src/atoms/navigation.atom'
import DeleteItListMenuItem from 'src/components/widgets/DeleteItListMenuItem/DeleteItListMenuItem'
import Icon from 'src/components/widgets/Icon/Icon'
import useItListOverflowMenu from 'src/lib/hooks/useItListOverflowMenu'

type OverflowMenuProps = {
  itList: Pick<ItList, 'id' | 'status'>
}

const OverflowMenu: React.FC<OverflowMenuProps> = ({ itList }) => {
  const backUrl = useRecoilValue(backUrlState)
  const { onClone, isOpen, setIsOpen, ref } = useItListOverflowMenu(itList)

  return (
    <Box position="relative" ref={ref}>
      <AnimatePresence key={'overflow'}>
        <IconButton
          as={motion.button}
          animate={{ opacity: 1 }}
          initial={{ opacity: 0 }}
          exit={{ opacity: 0 }}
          p={3}
          ml={4}
          aria-label="Options"
          onClick={(ev) => {
            ev.stopPropagation()
            setIsOpen((op) => !op)
          }}
          icon={
            <Icon
              boxSize="20px"
              display="flex"
              justifyContent="center"
              alignItems="center"
              icon={faEllipsis}
              data-testid="overflowMenu-meatBall"
            />
          }
          variant="outline"
          borderRadius="full"
          flex={1}
        />
      </AnimatePresence>
      <Menu isOpen={isOpen} isLazy variant="context">
        <MenuList width="190px" position="absolute" bottom="12px" right="-60px">
          <MenuItem
            data-testid="overflowMenu-cloneButton"
            icon={<Icon icon={faClone} fontSize={16} w="18px" />}
            onClick={onClone}
          >
            Clone to Drafts
          </MenuItem>
          <DeleteItListMenuItem
            itList={itList}
            label="Delete ItList"
            closeMenu={() => setIsOpen(false)}
            onDeleted={() => navigate(backUrl)}
          />
        </MenuList>
      </Menu>
    </Box>
  )
}

export default OverflowMenu
